webpackJsonp([10],{

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_role_new_vue__ = __webpack_require__(792);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ea44ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_role_new_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_role_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ea44ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_role_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(566));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(565));

var _alphaNum = _interopRequireDefault(__webpack_require__(568));

var _numeric = _interopRequireDefault(__webpack_require__(569));

var _between = _interopRequireDefault(__webpack_require__(570));

var _email = _interopRequireDefault(__webpack_require__(571));

var _ipAddress = _interopRequireDefault(__webpack_require__(572));

var _macAddress = _interopRequireDefault(__webpack_require__(573));

var _maxLength = _interopRequireDefault(__webpack_require__(574));

var _minLength = _interopRequireDefault(__webpack_require__(575));

var _required = _interopRequireDefault(__webpack_require__(576));

var _requiredIf = _interopRequireDefault(__webpack_require__(577));

var _requiredUnless = _interopRequireDefault(__webpack_require__(578));

var _sameAs = _interopRequireDefault(__webpack_require__(579));

var _url = _interopRequireDefault(__webpack_require__(580));

var _or = _interopRequireDefault(__webpack_require__(581));

var _and = _interopRequireDefault(__webpack_require__(582));

var _not = _interopRequireDefault(__webpack_require__(583));

var _minValue = _interopRequireDefault(__webpack_require__(584));

var _maxValue = _interopRequireDefault(__webpack_require__(585));

var _integer = _interopRequireDefault(__webpack_require__(586));

var _decimal = _interopRequireDefault(__webpack_require__(587));

var helpers = _interopRequireWildcard(__webpack_require__(558));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'https://ec-motor.makipos.la',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"SALES_URL":'https://ec-sales.makipos.la',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://maki-acl.s3.amazonaws.com/ACL/fenix.png',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(567).withParams : __webpack_require__(165).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_roles_role_form__ = __webpack_require__(938);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeModal() {
	this.goTo('page-role', { params: { codeCompany: this.codeCompany, codeProject: this.codeProject } });
}

function title() {
	var rol = 'Rol';
	return this.id ? 'Editar ' + rol : 'Crear ' + rol;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-role-new',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["default"],
		roleForm: __WEBPACK_IMPORTED_MODULE_1__components_roles_role_form__["a" /* default */]
	},
	computed: {
		title: title
	},
	methods: {
		closeModal: closeModal
	},
	props: {
		codeCompany: {
			type: String,
			required: true
		},
		codeProject: {
			type: String,
			required: true
		},
		id: {
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, record;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.loadResources();

						if (!(this.mode === 'edit')) {
							_context.next = 7;
							break;
						}

						_context.next = 4;
						return this.$http.get('role/' + this.roleId);

					case 4:
						_ref2 = _context.sent;
						record = _ref2.data;

						if (record.data) {
							if (record.data.configFilters) {
								record.data.configFilters.subsidiaries = record.data.configFilters.subsidiaries ? record.data.configFilters.subsidiaries : { subsidiaries: { fieldName: 'id', values: [] } };
							}
							this.model = {
								typeRoleId: record.data.typeRoleId,
								name: record.data.name,
								configFilters: record.data.configFilters ? record.data.configFilters : this.configFilters
							};
						}

					case 7:
						this.model.codeCompany = this.codeCompany;
						this.model.codeProject = this.codeProject;
						this.listRol();

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var listRol = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							codeProject: this.$route.params.codeProject
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get('types-roles', { params: params });

					case 4:
						response = _context2.sent;

						this.listRoles = response.data.data;
						_context2.next = 11;
						break;

					case 8:
						_context2.prev = 8;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 11:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 8]]);
	}));

	return function listRol() {
		return _ref3.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref5, resources;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$httpSales.get('companies/' + this.codeCompany + '/info');

					case 3:
						_ref5 = _context3.sent;
						resources = _ref5.data;

						this.subsidiaries = resources.subsidiaries;
						this.warehouses = resources.warehouses;
						_context3.next = 12;
						break;

					case 9:
						_context3.prev = 9;
						_context3.t0 = _context3['catch'](0);

						if (_context3.t0.response.status === 400) {
							if (_context3.t0.response.data.message === 'COMPANY_NOT_FOUND') {
								this.showNotification('No se encontraron datos de la compañía. Pero puedes seguir creando el rol sin problemas.', 'primary');
							}
						}

					case 12:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 9]]);
	}));

	return function loadResources() {
		return _ref4.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var method, url, headers;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						method = this.mode === 'create' ? 'post' : 'put';
						url = this.mode === 'create' ? 'role' : 'role/' + this.roleId;
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};

						this.loading = true;
						_context4.prev = 4;
						_context4.next = 7;
						return this.$http[method](url, this.model, { headers: headers });

					case 7:
						this.goTo(PAGE_ROLE_LIST);

					case 8:
						_context4.prev = 8;

						this.loading = false;
						return _context4.finish(8);

					case 11:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[4,, 8, 11]]);
	}));

	return function submitForm() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PAGE_ROLE_LIST = 'page-role';

function closeModal() {
	this.goTo(PAGE_ROLE_LIST);
}

function mode() {
	return this.roleId ? 'edit' : 'create';
}

function validations() {
	var validation = {
		model: {
			codeCompany: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
			},
			name: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
			},
			codeProject: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
			}
		}
	};
	return validation;
}

function data() {
	return {
		countries: [],
		configFilters: {
			sales: {
				subsidiaries: {
					fieldName: 'com_subsidiary_id',
					values: []
				}
			},
			warehouses: {
				subsidiaries: {
					fieldName: 'subsidiary_id',
					values: []
				},
				warehouses: {
					fieldName: 'id',
					values: []
				}
			},
			products: {
				warehouses: {
					fieldName: 'warehouse_id',
					values: []
				}
			},
			subsidiaries: {
				subsidiaries: {
					fieldName: 'id',
					values: [1, 2]
				}
			}
		},
		listRoles: [],
		loading: false,
		model: {
			codeProject: this.codeProject,
			name: '',
			codeCompany: this.codeCompany,
			isAdmin: true,
			typeRoleId: null,
			configFilters: {
				sales: {
					subsidiaries: {
						fieldName: 'com_subsidiary_id',
						values: []
					}
				},
				warehouses: {
					subsidiaries: {
						fieldName: 'subsidiary_id',
						values: []
					},
					warehouses: {
						fieldName: 'id',
						values: []
					}
				},
				products: {
					warehouses: {
						fieldName: 'warehouse_id',
						values: []
					}
				},
				subsidiaries: {
					subsidiaries: {
						fieldName: 'id',
						values: [1, 2]
					}
				}
			}
		},
		subsidiaries: [],
		warehouses: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'roles-form',
	created: created,
	computed: {
		mode: mode
	},
	data: data,
	methods: {
		closeModal: closeModal,
		listRol: listRol,
		loadResources: loadResources,
		submitForm: submitForm
	},
	props: {
		codeCompany: {
			type: String,
			required: true
		},
		codeProject: {
			type: String,
			required: true
		},
		roleId: {
			type: [Number, String]
		}
	},
	validations: validations
});

/***/ }),

/***/ 938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_form_vue__ = __webpack_require__(793);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b358ccf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_form_vue__ = __webpack_require__(939);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_role_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b358ccf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_role_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pt-0":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("\n\t\t\t\t\t\tTipo de Rol\n\t\t\t\t\t")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.listRoles,"background-color":"white","hide-details":"","chips":"","box":"","label":"Tipo de Rol","item-text":"name","item-value":"id"},model:{value:(_vm.model.typeRoleId),callback:function ($$v) {_vm.$set(_vm.model, "typeRoleId", $$v)},expression:"model.typeRoleId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("Nombre")]),_vm._v(" "),_c('v-text-field',{staticClass:"body-1 mt-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre","required":"","error":_vm.$v.model.name.$error},model:{value:(_vm.$v.model.name.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.name, "$model", $$v)},expression:"$v.model.name.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-0":""}},[_c('v-subheader',{staticClass:"pa-0 subheading"},[_vm._v("\n\t\t\t\t\t\tConfiguración de Filtros\n\t\t\t\t\t")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-0":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("\n\t\t\t\t\t\tListado de Ventas\n\t\t\t\t\t")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.subsidiaries,"background-color":"white","box":"","chips":"","hide-details":"","item-text":"sucursalName","item-value":"id","label":"Sucursales","multiple":""},model:{value:(_vm.model.configFilters.sales.subsidiaries.values),callback:function ($$v) {_vm.$set(_vm.model.configFilters.sales.subsidiaries, "values", $$v)},expression:"model.configFilters.sales.subsidiaries.values"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("\n\t\t\t\t\t\tListado de Almacenes\n\t\t\t\t\t")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.subsidiaries,"background-color":"white","box":"","chips":"","hide-details":"","item-text":"sucursalName","item-value":"id","label":"Sucursales","multiple":""},model:{value:(_vm.model.configFilters.warehouses.subsidiaries.values),callback:function ($$v) {_vm.$set(_vm.model.configFilters.warehouses.subsidiaries, "values", $$v)},expression:"model.configFilters.warehouses.subsidiaries.values"}}),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.warehouses,"background-color":"white","box":"","chips":"","hide-details":"","item-text":"name","item-value":"id","label":"Almacenes","multiple":""},model:{value:(_vm.model.configFilters.warehouses.warehouses.values),callback:function ($$v) {_vm.$set(_vm.model.configFilters.warehouses.warehouses, "values", $$v)},expression:"model.configFilters.warehouses.warehouses.values"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("\n\t\t\t\t\t\tListado de Productos\n\t\t\t\t\t")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.warehouses,"background-color":"white","box":"","chips":"","hide-details":"","item-text":"name","item-value":"id","label":"Almacenes","multiple":""},model:{value:(_vm.model.configFilters.products.warehouses.values),callback:function ($$v) {_vm.$set(_vm.model.configFilters.products.warehouses, "values", $$v)},expression:"model.configFilters.products.warehouses.values"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"body-1",attrs:{"for":"title"}},[_vm._v("\n\t\t\t\t\t\tListado de Sucursales\n\t\t\t\t\t")]),_vm._v(" "),_c('v-select',{staticClass:"body-1 mt-2",attrs:{"items":_vm.subsidiaries,"background-color":"white","box":"","chips":"","hide-details":"","item-text":"sucursalName","item-value":"id","label":"Sucursales","multiple":""},model:{value:(_vm.model.configFilters.subsidiaries.subsidiaries.values),callback:function ($$v) {_vm.$set(_vm.model.configFilters.subsidiaries.subsidiaries, "values", $$v)},expression:"model.configFilters.subsidiaries.subsidiaries.values"}})],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid || _vm.loading,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true},on:{"close-modal":_vm.closeModal}},[_c('role-form',{attrs:{"role-id":_vm.id,"code-company":_vm.codeCompany,"code-project":_vm.codeProject}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.cc55241ac55445307952.js